import React from "react";

const Profile = (props) => 
	<li>
		<a href="#" title="Help" className=" dropdown-toggle">
			<i className="icon glyphicon glyphicon-user"></i>
		</a>
	</li>;

export default Profile;


/** WEBPACK FOOTER **
 ** ./src/scripts/components/header/Profile.jsx
 **/